module.exports = __webpack_public_path__ + "media/react/fonts/fa-regular-400-264d0da793817800809d0819d96b47a4.ttf";